import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { NotificationRef } from '../notification.service';
import { FiCustomerDataService } from '../../../shared/fi-shared-services/fi-customer-data.service';

@Component({
    selector: 'fi-platform-shut-down-notification',
    template: `
        <div class="fi-platform-shut-down BrandedBackgroundColor" [ngClass]="">
            <div class="fi-platform-shut-down-inner">
                <div class="fi-platform-shut-down-title" [textContent]="'billing.shutdown_title' | fiAppText"></div>
                <div
                    class="fi-platform-shut-down-text"
                    [innerHTML]="'billing.shutdown_text1' | fiAppText: { '{0}': getDateText() }"
                ></div>
                <div class="fi-platform-shut-down-text" [innerHTML]="'billing.shutdown_text2' | fiAppText"></div>
            </div>
            <div class="fi-platform-shut-down-button fi-platform-shut-down-button-solve">
                <button mat-flat-button (click)="onSolveClick()">{{ 'billing.solve_now' | fiAppText }}</button>
            </div>
            <div class="fi-platform-shut-down-button">
                <button mat-icon-button (click)="onHideClick()">
                    <mat-icon class="fas fa-times fa-lg"></mat-icon>
                </button>
            </div>
        </div>
    `,
    styleUrls: ['./platform-shut-down-notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlatformShutDownNotificationComponent {
    constructor(
        @Inject(NotificationRef) private notiRef,
        private customerDataService: FiCustomerDataService,
    ) {}

    onHideClick() {
        this.notiRef.HideNotification();
    }

    onSolveClick() {
        window.location.href = 'https://payment.chainformation.com';
    }

    getDateText() {
        const date = new Date(this.customerDataService.getCustomerData().ShutOffDate);
        return ('0' + date.getDate()).slice(-2) + ' / ' + ('0' + (date.getMonth() + 1)).slice(-2);
    }
}
